export const BULK_ACCEPTED_EXTENSIONS = [
  "xlsx",
  "csv",
  "tsv",
  "pdf",
  "md",
  "markdown",
  "txt",
];

export const BULK_ACCEPT_ATTRIBUTE = BULK_ACCEPTED_EXTENSIONS.map(
  (extension) => `.${extension}`
).join(",");
export const BULK_MAX_FILE_BYTES = 7 * 1024 * 1024;

const BULK_FILE_ERROR = {
  unsupportedFileType: "unsupportedFileType",
  emptyFile: "emptyFile",
  fileTooLarge: "fileTooLarge",
};

export const getFileExtension = (fileName = "") => {
  const parts = String(fileName).toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
};

export const validateBulkFile = (file) => {
  if (!file || file.size === 0) return BULK_FILE_ERROR.emptyFile;
  if (!BULK_ACCEPTED_EXTENSIONS.includes(getFileExtension(file?.name))) {
    return BULK_FILE_ERROR.unsupportedFileType;
  }
  if (file.size > BULK_MAX_FILE_BYTES) return BULK_FILE_ERROR.fileTooLarge;
  return null;
};

export const formatBulkFileSize = (bytes = 0) => {
  const size = Number(bytes) || 0;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} KB`;
  const rounded = Math.round((size / (1024 * 1024)) * 10) / 10;
  return `${rounded} MB`;
};
